module.exports = __webpack_public_path__ + "static/media/Promo-Allfresco-Principal.a9dac4a2.webp";